import styled from "styled-components";
import Navbar from "react-bootstrap/Navbar";
import { getImageURL } from "../../utilities";

const StyledHeader = styled(Navbar)`
  & {
    height: 8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent !important;
    transition: background-color 0.3s ease-in, height 0.3s ease-in, transform 0.3s ease-in;
    padding: 0 !important;
  }
  
  &.active {
    height: 5rem;
    background-color: var(--darkBlue) !important;
  }

  & .navbar-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
  }

  & .logo-container {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  & .userway-container {
    position: absolute;
    right: 5%;
    margin-top: -2rem;
  }

  & .navbar-brand {
    width: 300px;
    height: 4.5rem;
    background-image: url("https://resources.swmc.com/swmc-images/sunwest-trust-white-logo.png");
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 !important;
    transition: background-color 0.3s ease-in, height 0.3s ease-in, transform 0.3s ease-in;
  }

  &.nav-transition {
    transform: translateY(-100%);
  }

  @media (max-width: 500px) {
    & {
      height: 8rem;
    }

    &.active {
      height: 4rem;
    }
    
    & .navbar-brand {
      width: 200px;
      height: 4rem;
    }
    & .userway-container {
    right: 10%;
    margin-top: -2rem;
  }
  }
`;

export default StyledHeader;